import {
  AlertsPanel,
  PageContainer,
  PageHeader,
  PageInfoTooltip,
  PageTitle,
  PageTitleGroup,
} from "../shared";

/**
 * Alerts admin page (EN-5165), migrated from the Retool Alerts app.
 *
 * `page_Alerts` was a thin wrapper around `moduleAlerts` with `patientId`
 * left blank — so the page is a thin wrapper around `AlertsPanel` with no
 * patient filter, and the module stays embeddable for the Patients tickets.
 */
export function AdminAlerts() {
  document.title = "Alerts - Admin";

  return (
    <PageContainer>
      <PageHeader>
        <PageTitleGroup>
          <PageTitle>Alerts</PageTitle>
          <PageInfoTooltip title="Alerts">
            Measurement alerts configured across every ward, and who changed
            them. These are the rules set to fire — an alert that has actually
            fired shows on the patient&apos;s own record.
          </PageInfoTooltip>
        </PageTitleGroup>
      </PageHeader>

      <AlertsPanel />
    </PageContainer>
  );
}
